import { cmsHttpService } from '@services/http';

const fetchHtml = async (id: string): Promise<string> => {
    return await cmsHttpService.get<string>(id);
};

export default fetchHtml;
